<h2 mat-dialog-title>
  {{ 'settingsSubjectModelImageUploadDialog.uploadSubjectModelImage' | translate }}
</h2>
<div class="container" fxLayout="column" fxLayoutAlign="start center">
  <div class="form-container" fxLayout="column" fxLayoutGap="5px">
    <div class="subject-image" fxLayout="column" fxLayoutAlign="end start">
      <button class="uploadbutton" mat-button color="primary" (click)="openFileManager()">
        <mat-icon aria-label="">unarchive</mat-icon>{{ 'settingsSubjectModelImageUploadDialog.selectImage' | translate }}
      </button>
      <div class="subject-cad-div">
        <img class="subject-cad-image" fxLayoutAlign="start start" src="{{uploadImagePath ? uploadImagePath : subjectModel ? subjectModel.structImagePath : null}}" />
      </div>
      <input hidden #uploadbuttoninput type="file" accept="image/*" (change)="uploadImage($event.target.files); uploadbuttoninput.value=''" />
    </div>
    <div fxFlex></div>
    <div fxLayout="row" fxLayoutAlign="center">
      <mat-dialog-actions>
        <button mat-button color="primary" mat-dialog-close>{{ 'settingsSubjectModelImageUploadDialog.cancel' | translate }}</button>
        <button mat-raised-button [disabled]="!uploadFile || isTrans" color="primary" (click)="submit()">
          {{ 'settingsSubjectModelImageUploadDialog.upload' | translate }}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>